module.exports = __webpack_public_path__ + "img/ic_name.25e2b0e2.svg";